import { IVitalSyncRepository } from "../../adapters/driven/repositories/vitalSyncRepository";

export const VitalSyncServiceImplFactory = ({
  vitalSyncRepository,
}: {
  vitalSyncRepository: IVitalSyncRepository;
}) => {
  const extractVitals: IExtractVitalsService = async (payload) => {
    try {
      const response = await vitalSyncRepository.ExtractVitalsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const submitVitalsToPCC: ISubmitVitalsToPCCService = async (payload) => {
    try {
      const response = await vitalSyncRepository.SubmitVitalsToPCCAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPCCSubmissionStatistics: IGetPCCSubmissionStatisticsService = async (
    payload
  ) => {
    try {
      const response = await vitalSyncRepository.GetPCCSubmissionStatisticsAPI(
        payload
      );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPCCQueueList: IGetPCCQueueListService = async (payload) => {
    try {
      const response = await vitalSyncRepository.GetPCCQueueListAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    extractVitals,
    submitVitalsToPCC,
    getPCCSubmissionStatistics,
    getPCCQueueList,
  };
};
